/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Domain,
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
} from './Domain';
import {
    FundamentalDomain,
    FundamentalDomainFromJSON,
    FundamentalDomainFromJSONTyped,
    FundamentalDomainToJSON,
} from './FundamentalDomain';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';
import {
    ScienceBranch,
    ScienceBranchFromJSON,
    ScienceBranchFromJSONTyped,
    ScienceBranchToJSON,
} from './ScienceBranch';

/**
 * 
 * @export
 * @interface DomainLearningOutcomeTemplate
 */
export interface DomainLearningOutcomeTemplate {
    /**
     * 
     * @type {string}
     * @memberof DomainLearningOutcomeTemplate
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof DomainLearningOutcomeTemplate
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DomainLearningOutcomeTemplate
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DomainLearningOutcomeTemplate
     */
    identificator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainLearningOutcomeTemplate
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof DomainLearningOutcomeTemplate
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DomainLearningOutcomeTemplate
     */
    fundamentalDomainId?: string | null;
    /**
     * 
     * @type {FundamentalDomain}
     * @memberof DomainLearningOutcomeTemplate
     */
    fundamentalDomain?: FundamentalDomain;
    /**
     * 
     * @type {string}
     * @memberof DomainLearningOutcomeTemplate
     */
    scienceBranchId?: string | null;
    /**
     * 
     * @type {ScienceBranch}
     * @memberof DomainLearningOutcomeTemplate
     */
    scienceBranch?: ScienceBranch;
    /**
     * 
     * @type {string}
     * @memberof DomainLearningOutcomeTemplate
     */
    domainId?: string | null;
    /**
     * 
     * @type {Domain}
     * @memberof DomainLearningOutcomeTemplate
     */
    domain?: Domain;
}

export function DomainLearningOutcomeTemplateFromJSON(json: any): DomainLearningOutcomeTemplate {
    return DomainLearningOutcomeTemplateFromJSONTyped(json, false);
}

export function DomainLearningOutcomeTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainLearningOutcomeTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'identificator': !exists(json, 'identificator') ? undefined : json['identificator'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'fundamentalDomainId': !exists(json, 'fundamentalDomainId') ? undefined : json['fundamentalDomainId'],
        'fundamentalDomain': !exists(json, 'fundamentalDomain') ? undefined : FundamentalDomainFromJSON(json['fundamentalDomain']),
        'scienceBranchId': !exists(json, 'scienceBranchId') ? undefined : json['scienceBranchId'],
        'scienceBranch': !exists(json, 'scienceBranch') ? undefined : ScienceBranchFromJSON(json['scienceBranch']),
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'domain': !exists(json, 'domain') ? undefined : DomainFromJSON(json['domain']),
    };
}

export function DomainLearningOutcomeTemplateToJSON(value?: DomainLearningOutcomeTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'identificator': value.identificator,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'fundamentalDomainId': value.fundamentalDomainId,
        'fundamentalDomain': FundamentalDomainToJSON(value.fundamentalDomain),
        'scienceBranchId': value.scienceBranchId,
        'scienceBranch': ScienceBranchToJSON(value.scienceBranch),
        'domainId': value.domainId,
        'domain': DomainToJSON(value.domain),
    };
}

